import { Button, Image, List, Modal, Space, Tag, Typography } from 'antd';
import { EyeOutlined, FileOutlined } from '@ant-design/icons';
import { useEffect, useMemo, useState } from 'react';

const { Text } = Typography;

const getFileName = (item) => item?.file_name || item?.name || item?.originFileObj?.name || 'Attachment';
const getRemoteUrl = (item) => item?.attachment || item?.url || '';
const isImageFile = (name = '', type = '') => type.startsWith('image/') || /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(name);
const isPdfFile = (name = '', type = '') => type === 'application/pdf' || /\.pdf$/i.test(name);

export const WarningLetterAttachmentList = ({ attachments = [], compact = false }) => {
  const [preview, setPreview] = useState(null);
  const localUrls = useMemo(() => new Map(), []);

  useEffect(() => () => {
    localUrls.forEach((url) => URL.revokeObjectURL(url));
    localUrls.clear();
  }, [localUrls]);

  const resolvePreview = (item) => {
    const name = getFileName(item);
    const rawFile = item?.originFileObj || (item instanceof File ? item : null);
    const type = rawFile?.type || item?.type || '';
    let url = getRemoteUrl(item);

    if (!url && rawFile) {
      if (!localUrls.has(rawFile)) localUrls.set(rawFile, URL.createObjectURL(rawFile));
      url = localUrls.get(rawFile);
    }

    if (!url) return;
    setPreview({ name, url, type, image: isImageFile(name, type), pdf: isPdfFile(name, type) });
  };

  if (!attachments?.length) return <Text type="secondary">Tidak ada attachment</Text>;

  return (
    <>
      <List
        size="small"
        dataSource={attachments}
        renderItem={(item) => {
          const name = getFileName(item);
          const rawFile = item?.originFileObj || (item instanceof File ? item : null);
          const type = rawFile?.type || item?.type || '';
          return (
            <List.Item
              style={compact ? { paddingInline: 0 } : undefined}
              actions={[<Button key="preview" size="small" icon={<EyeOutlined />} onClick={() => resolvePreview(item)}>Preview</Button>]}
            >
              <Space>
                <FileOutlined />
                <Text ellipsis style={{ maxWidth: compact ? 230 : 420 }}>{name}</Text>
                {isPdfFile(name, type) && <Tag>PDF</Tag>}
                {isImageFile(name, type) && <Tag color="blue">IMAGE</Tag>}
              </Space>
            </List.Item>
          );
        }}
      />

      <Modal
        title={`Preview Attachment - ${preview?.name || ''}`}
        open={Boolean(preview)}
        onCancel={() => setPreview(null)}
        footer={preview ? (
          <Space>
            <Button href={preview.url} target="_blank" rel="noreferrer">Buka di Tab Baru</Button>
            <Button onClick={() => setPreview(null)}>Tutup</Button>
          </Space>
        ) : null}
        width={900}
        destroyOnClose
      >
        {preview?.image ? (
          <div style={{ textAlign: 'center' }}>
            <Image src={preview.url} alt={preview.name} style={{ maxHeight: '70vh', objectFit: 'contain' }} />
          </div>
        ) : (
          <iframe
            title={preview?.name || 'Attachment preview'}
            src={preview?.url}
            style={{ width: '100%', height: '70vh', border: 0 }}
          />
        )}
      </Modal>
    </>
  );
};
